<template>
  <svg
    viewBox="0 0 752 752"
    style="fill: currentColor; height: 1rem; margin: -0.1rem 0.1rem 0.1rem -0.1rem; transform: scale(2)"
  >
    <path d="m 257.13273,447.36904 v 35 h 331.51 v -35 c -124.76466,0.4264 -216.49281,0 -331.51,0 z" />
    <path d="m 257.07892,536.73449 v 35 h 331.51 v -35 c -124.76466,0.4264 -216.49281,0 -331.51,0 z" />
    <path d="m 256.91051,177.07876 v 35 h 331.51 v -35 c -124.76466,0.4264 -216.49281,0 -331.51,0 z" />
    <path d="m 256.8567,266.44421 v 35 h 331.51 v -35 c -124.76466,0.4264 -216.49281,0 -331.51,0 z" />
    <path d="m162.89 288.39v175.22l87.613-87.613z" />
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped></style>
